'use strict';

angular.module('docketbook').
  service('batchService', function(accessControl, $http, $stateParams, $cookies, $q, Restangular, geolocation) {

    /***** Get Org/Group Docket Batches *****/
    this.getBatches = function(params, successCb, failureCb) {
      var currentOrg = accessControl.currentOrg();
      var currentOrgGroup = accessControl.currentOrgGroup();
      var baseBatches = Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('docket_batches');
      baseBatches.getList().then(function(batches) {
        successCb(batches);
      }, failureCb);
    }

    this.saveBatch = function(batchData, successCb, failureCb) {
      var currentOrg = accessControl.currentOrg();
      var currentOrgGroup = accessControl.currentOrgGroup();
      var baseBatches = Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('docket_batches');
      if ( batchData.id == null ) {
        baseBatches.customPOST(batchData).then(successCb, failureCb);
      } else {
        baseBatches.one(batchData.id).customPUT(batchData).then(successCb, failureCb);
      }
    }

    this.getBatch = function(batchId, successCb, failureCb) {
      var currentOrg = accessControl.currentOrg();
      var currentOrgGroup = accessControl.currentOrgGroup();
      var baseBatches = Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('docket_batches');
      if ( batchId.id != null ) {
        batchId = batchId.id;
      }
      baseBatches.customGET(batchId).then(successCb, failureCb);
    }

    var deleteBatch = function(batchId, successCb, failureCb) {
      var currentOrg = accessControl.currentOrg();
      var currentOrgGroup = accessControl.currentOrgGroup();
      var baseBatches = Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('docket_batches');
      if ( batchId.id != null ) {
        batchId = batchId.id;
      }
      baseBatches.one(batchId).remove().then(successCb, failureCb);
    }

    this.deleteBatch = deleteBatch;

    /***** Delete Bulk Batches *****/
    this.deleteBulkBatches = function(batches, successCb) {
      var failures = [];
      deleteBatches(batches, 0, failures, function(failuresFilled) {
        successCb(failuresFilled);
      });
    }

    var deleteBatches = function(list, index, failures, successCb) {
      if ( index >= list.length ) {
        successCb(failures);
        return;
      }

      deleteBatch(list[index].id, function(success) {
        deleteBatches(list, index + 1, failures, successCb);
      }, function(err) {
        failures.push(list[index]);
        deleteBatches(list, index + 1, failures, successCb);
      });
    }

});



// WEBPACK FOOTER //
// ./src/services/batchService.js